import React from 'react';

export const MapEmbed = ({ query, zoom = 10, className = 'w-full h-64', testId }) => (
  <iframe
    data-testid={testId || `map-embed-${query.toLowerCase().replace(/[^a-z0-9]+/g, '-')}`}
    title={`Map of ${query}`}
    src={`https://maps.google.com/maps?q=${encodeURIComponent(query)}&t=&z=${zoom}&ie=UTF8&iwloc=&output=embed`}
    className={`${className} border-0`}
    loading="lazy"
    allowFullScreen
    referrerPolicy="no-referrer-when-downgrade"
  />
);
